import * as React from 'react'
import messages from '../messages/en'
import KVTitle from '../assets/titles/Everything_We_Do_Is.png'
import OurPolicies from '../assets/titles/Our_Policies.png'
import RelatedWebsites from '../assets/titles/Related_Websites.png'
import HomeIndex from '../components/HomeIndex'
import { Language } from '../Language'
import { FontsContext } from '../context'
import { fonts } from '../constants'

export default () => {
  return (
    <FontsContext.Provider value={fonts.en}>
      <HomeIndex
        messages={messages}
        titles={{ KVTitle, OurPolicies, RelatedWebsites }}
        language={Language.EN}
      />
    </FontsContext.Provider>
  )
}
